import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import Slabs from '@/features/points-management/points-configuration/affiliateTable/slabs';
import { Translation } from '@/hoslog-intl';
import { SettingIcon } from '@/icons';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum(['fromAmount', 'toAmount', 'value']),
  desc: z.boolean(),
});

const searchSchema = z
  .object({
    activeTab: z.enum(['affiliate', 'club', 'customer']),
    categoryName: z.string().optional(),
    page: z.coerce.number().nonnegative().catch(0),
    fetch: z.coerce.number().positive().max(100).catch(10),
    q: z.string().optional(),
    createdDate: z.string().optional(),
    sort: z
      .preprocess((value) => {
        if (typeof value === 'string') {
          try {
            return JSON.parse(value);
          } catch {
            return undefined;
          }
        }

        return value;
      }, z.array(sortItemSchema))
      .optional(),
  })
  .passthrough();

export const Route = createFileRoute('/(app)/points-management/points-configuration/affiliate/$pointCategoryId/slabs')({
  loader: () => ({
    crumb: <CrumbTitle id="pointManagement.page.form.table.title" icon={SettingIcon} />,
    title: <Translation id="pointManagement.page.form.table.title" />,
  }),
  component: Slabs,
  validateSearch: (search: SearchSchemaInput) => searchSchema.parse(search),
});
